import { generatePath } from 'react-router-dom';

import { FileType } from '@/components/pages/Applicant/Applicant.types';

import { APIRoutes } from '../../routes';
import apiInstance from '../index';

export async function getFile(fileId: string): Promise<string> {
    const endpointUrl = generatePath(APIRoutes.FILE_BY_ID, {
        fileId,
    });
    return (await apiInstance.get<string>(endpointUrl)).data;
}

export interface UpdateFilenameRequest {
    fileId: string;
    fileName: string;
}

export interface UpdateFilenameResponse {
    success: boolean;
    message?: string;
}

export async function updateFilename(
    request: UpdateFilenameRequest,
): Promise<UpdateFilenameResponse | undefined> {
    const endpointUrl = generatePath(APIRoutes.FILE_UPDATE_FILENAME, {
        fileId: request.fileId,
    });
    return (
        await apiInstance.put<UpdateFilenameResponse | undefined>(endpointUrl, {
            fileName: request.fileName,
        })
    ).data;
}

export async function softDeleteFile(fileId: string): Promise<void> {
    const endpointUrl = generatePath(APIRoutes.FILE_BY_ID, {
        fileId,
    });
    await apiInstance.delete(endpointUrl);
}

export interface UpdateDocumentTypeRequest {
    fileId: string;
    documentType: FileType;
}

export async function updateDocumentType(
    request: UpdateDocumentTypeRequest,
): Promise<boolean | null> {
    const endpointUrl = generatePath(APIRoutes.FILE_UPDATE_DOCUMENT_TYPE, {
        fileId: request.fileId,
    });
    const response = await apiInstance.put<boolean | null>(endpointUrl, {
        documentType: FileType[request.documentType],
    });
    return response.data;
}
